import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const Container = styled(Paper)`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const ContainerItens = styled.div`
  padding: 10px;
`